import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Trophy, Star, Award } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

export const ProfilePage: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  if (!user) {
    return (
      <div className="relative min-h-[calc(100vh-4rem)] p-6">
        <div className="absolute inset-0 backdrop-blur-md bg-indigo-950/50 flex items-center justify-center z-10">
          <div className="max-w-md text-center p-8 bg-white/10 rounded-lg backdrop-blur-lg">
            <Trophy className="w-16 h-16 text-purple-300 mx-auto mb-4" />
            <h2 className="text-2xl font-bold text-purple-200 mb-4">
              Desbloqueie Seu Perfil Personalizado
            </h2>
            <p className="text-purple-200/70 mb-6">
              Crie sua conta agora e tenha acesso a:
            </p>
            <ul className="space-y-3 text-left mb-6">
              <li className="flex items-center text-purple-200/80">
                <Star className="w-5 h-5 mr-2 text-purple-300" />
                Sistema de níveis e recompensas
              </li>
              <li className="flex items-center text-purple-200/80">
                <Award className="w-5 h-5 mr-2 text-purple-300" />
                Conquistas exclusivas
              </li>
            </ul>
            <button 
              onClick={() => navigate('/signup')}
              className="w-full btn-primary"
            >
              Cadastre-se Agora
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6 pt-8 min-h-[calc(100vh-4rem)] space-y-6">
      <div className="flex items-center justify-between mb-8">
        <div className="flex items-center space-x-4">
          <div className="w-20 h-20 rounded-full bg-purple-500/20 flex items-center justify-center">
            <Trophy className="w-10 h-10 text-purple-300" />
          </div>
          <div>
            <h2 className="text-2xl font-bold text-purple-200">{user.name}</h2>
            <p className="text-purple-300/70">
              Membro desde {user.created_at ? new Date(user.created_at).toLocaleDateString('pt-BR') : '—'}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};